const DisclaimerSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div class="container">
      <div class="about__wrapper">
        <div class="row gx-5  gy-4 gy-sm-0  align-items-center">
          
          <div class="col-lg-12">
            <div class="about__content" data-aos="fade-left" data-aos-duration="800">
              <div class="about__content-inner">
                {/* <!-- <h2 class="meet-oppurtanity">Desclaimer<span> </span></h2> --> */}
                <p class="text-justify">
                All reasonable care has been taken to ensure that the information contained herein is not misleading or untrue at the time of publication. However, we make no long standing commitment as to its accuracy or completeness. All information is for the private use of the person to whom it is provided without any liability whatsoever on the part of <b>Asiatic Stock & Securities LTD</b> or any associated company or any member of employee thereof.</p>

                <p class="text-justify"><b>Asiatic Stock & Securities LTD</b> may have open and investment interest in the stocks mentioned herein. Nothing contained herein should be construed as an offer to buy or sell or a solicitation of an offer to buy or sell. The value of any investment may fall as well as rise. Investors are advised to avail personal counseling from our research or dealing desk if they wish for any further clarity or clarifications in the understanding on various aspects of investment.</p>

                <p class="text-justify">
                <b> Asiatic Stock & Securities LTD</b> has taken due care and caution in compilation of data for its web site. The views and investment tips expressed by investment experts on <b>Asiatic Stock & Securities LTD</b> are their own, and not that of the site. <b>Asiatic Stock & Securities LTD</b> advices users to check with certified experts before taking any investment decision. However, <b>Asiatic Stock & Securities LTD</b> does not guarantee the accuracy, adequacy or completeness of any information and is not responsible for any errors or omissions or for the results obtained from the use of such information. <b>Asiatic Stock & Securities LTD</b> especially states that it has no financial liability whatsoever to any user on account of the use of information provided on its website.
                </p>
 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default DisclaimerSection;
